import { Link } from "react-router-dom";

export default function UpgradePrompt({ message, feature }) {
  return (
    <div style={s.wrapper}>
      <span style={s.icon}>🔒</span>
      <div>
        <p style={s.title}>{feature} — Paid Feature</p>
        <p style={s.message}>{message || "Upgrade to Basic or Pro to unlock this feature."}</p>
      </div>
      <Link to="/subscription" style={s.btn}>Upgrade Now</Link>
    </div>
  );
}

const s = {
  wrapper: {
    background: "#0f1a1a", border: "1px solid #1e3333",
    borderRadius: "12px", padding: "20px 24px",
    display: "flex", alignItems: "center",
    gap: "16px", flexWrap: "wrap",
    marginBottom: "24px",
  },
  icon: { fontSize: "24px", flexShrink: 0 },
  title: { fontSize: "15px", fontWeight: "700", color: "#e8f5f5", marginBottom: "4px" },
  message: { fontSize: "13px", color: "#5a8a8a" },
  btn: {
    background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
    color: "#0a0f0f", borderRadius: "8px", padding: "10px 20px",
    fontSize: "13px", fontWeight: "700", textDecoration: "none",
    flexShrink: 0, marginLeft: "auto",
  },
};